
<template>
  <div class="registerContainer">
      <div class="topLogo" >
        <button @click="myCamera">拍照</button><button @click="myGallery">相册选取</button>
      </div>
      <div class="imgOne">
          <img :src="img" class="imgOne">
      </div>
        <div class="crop" v-if="cropShow">
          <p  class="alert" v-show="!crop">图片加载中，请等待...</p>
          <vueCropper v-show="crop"
            ref="cropper"
            :info="false"
            :autoCrop="true"
            :img="option.img"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :canMoveBox="false"
            :fixedBox="true"
          ></vueCropper>
            <!-- 下方取消确认按钮 -->
           <div class="fot">
             <p @touchend="cancelCut">取消</p><p @touchend="cut">完成</p>
           </div>
        </div>
  </div>
</template>
<script>
import VueCropper from 'vue-cropper';
import base64 from '@/common/js/base/base64.js'
export default {
  components:{VueCropper},
  data(){
      return{
          option:{
            img:'',
            outputType:'jpg',
            autoCropWidth:document.body.offsetWidth*.8 ,
	       		autoCropHeight:document.body.offsetWidth *.8,
          },
          cropShow:false,
          crop:false,//裁剪显示隐藏
          photoType:'',
          img:'',//初始头像=>裁剪过后的图片
      }
  },
  watch:{

  },
  methods:{
      cancelCut(){//取消裁剪后的操作
        if(this.photoType==1){
          this.myCamera()
        }else if(this.photoType==2){
          this.myGallery()
        }
      },
      cut(){//裁剪图片
      this.$refs.cropper.getCropData((data) => {
        // do something
        this.img=data;//=>这里是裁剪后的图片
        console.log(data)
        this.cropShow=false
        this.crop=false
        })
      },
    myCamera(){//调用手机拍照
      var that=this
      that.photoType=1
      if(window.plus){
          plusReady();
        }else{
          document.addEventListener("plusready",plusReady,false);
        }
        var cmr = plus.camera.getCamera();
        var res = cmr.supportedImageResolutions[0];
        var fmt = cmr.supportedImageFormats[0];
            that.cropShow=true//裁剪遮罩层显示
          cmr.captureImage( function( path ){
            plus.io.resolveLocalFileSystemURL(path,function(entry){
               base64.compressImage(entry.toLocalURL())
               that.option.img=entry.toLocalURL()
               that.crop=true//裁剪显示
            })
            },
          function( error ) {
               that.cropShow=false
               that.crop=false
              console.log( "取消拍照" );
          },
          {resolution:res,format:fmt}
        );
    },
    myGallery(){//手机相册
          let that=this;
          that.photoType=2
           plus.gallery.pick( function(path){
    	         plus.io.resolveLocalFileSystemURL(path,function(entry){
                  // alert(entry.toLocalURL())
                  that.option.img=entry.toLocalURL()
                  that.cropShow=true
                  that.crop=true
                })
            }, function ( e ) {
              that.cropShow=false
                  that.crop=false
              console.log( "取消选择图片" );
            }, {filter:"image"} );
    },
  },
  mounted(){//将图片转换base64
  }
}
</script>
<style>
.imgOne{
  width: 1.2rem;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/change/photo.vue